<template>
  <div class="home">
    <!-- <div class="header-view">
      {{ title }}
    </div> -->
    <div class="main-view">
      <div class="html">
        <div class="area-title">修改前</div>
        <div v-html="selectedElementHtmlNew"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <div class="html">
        <div class="area-title">变更</div>
        <div v-html="selectedElementHtmlDiff"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <div class="html">
        <div class="area-title">修改后</div>
        <div v-html="selectedElementHtml"></div>
        <!-- <div v-html="articleElementHtml"></div> -->
      </div>
      <!-- <button @click="goPracticeView">Practice</button> -->
      
    </div>
    <!-- <div class="tools-view">
      <div class="btns-div">
        <img src="../assets/catalog.png" alt="" class="tool-img" @click="showCatalog">
      </div>
      <div class="btns-div">
        <img src="../assets/leftArrow.png" alt="" class="tool-img" @click="showPre">
      </div>
      <div class="btns-div">
        <img src="../assets/rightArrow.png" alt="" class="tool-img" @click="showNext">
      </div>
      <div class="btns-div">
        <img src="../assets/fontsize.png" alt="" class="tool-img" @click="changeFont">
      </div>
    </div>
    <div class="font-slider" v-if="showFontsizeChangeTool">
      <el-slider
      v-model="fontSize"
      :step="1"
      :marks="marks"
      :min="0"
      :max="7"
      show-stops>
     </el-slider>
    </div> -->
    <!-- <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false" v-if="textBookInfoVo!=null && textBookInfoVo.unitList!=null">
      <div class="catalog">
        <div class="unit-label" v-for="item,unitIndex in textBookInfoVo.unitList" :key="unitIndex">
          <div class="unit-name" style="font-weight: bold;height: 40px;line-height: 40px;">
            {{item.serialName}}&nbsp;&nbsp; {{item.title}}
          </div>
          <div class="lesson-label" v-for="lesson,lessonIndex in item.lessonList" :key="lessonIndex">
            <div class="lesson-name" style="margin-left: 20px;height: 30px;line-height: 30px;" @click="gotoDetail(item.id,lesson)">
              {{lesson.serialName}}&nbsp;&nbsp; {{lesson.title}}
            </div>
          </div>
        </div>
      </div>
    </el-drawer> -->
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import { loadJS,loadCSS,loadBodyJS,removeAllDetailSource } from "@/utils/wmtools.js"
import axios from 'axios';
import {baseUri, auditBaseUri, prefix, bookVersion} from '@/utils/cdn.js'

import htmldiff from "@/utils/htmldiff.js";
import TextBookApi from "../../../api/src/textbook/api/TextBookApi"
const textbookApi = new TextBookApi();

// import TextBookApi from "@/api/src/textbook/api/TextBookApi.js";
// const textBookApi = new TextBookApi()



const Authorization = ''
export default {
  components:{
  },
  data() {
    return {
      frameUrl:null,
      diffFrameUrl: undefined,
      navTitle: '',
      title:"",
      baseFrameUrl:'',
      textbookId:null,
      unitId:null,
      lessonId:null,
      lessonFile:null,
      filePath:null,
      selectedElementHtml:"",
      selectedElementHtmlNew:"",
      articleElementHtml:"",
      drawer: false,
      lessonList:[],
      currentLessonIndex: -1,
      fontSize: 0,
      textBookInfoVo:null,
      marks: {
        0: '小',
        7: '大'
      },
      showFontsizeChangeTool:false,
      selectedElementHtmlDiff:""
    }
  },
  computed: {
    
  },
  destroyed(){
    document.body.className = '';
    removeAllDetailSource()
  },
  async mounted() {
    const {textbookId,unitId,filePath,lessonId,title} = this.$route.params
    this.title = title
    this.textbookId = textbookId
    this.unitId = unitId
    this.filePath = filePath
    this.lessonId = lessonId
    removeAllDetailSource()
    await this.loadInfoData()
    //修改窗口title
    document.title = this.title
    // this.frameUrl = "/rawdata/online/8093380284517515264/7989331510455501330/c01s01.html?Expires=1719976537&OSSAccessKeyId=TMP.3KjQ42hkhHuyD2bhKnPp7pioJKauNDad3ZK9efXJeUDSyTiwY6zp5fX3uPtH3wWPFZxAnX8gNSbACr7feBcq8iUMdpWUek&Signature=0X5akI6AtP02%2FnK%2FizgePh3ZBK4%3D"
    // this.frameUrl = `https://cdn.aefree.com/rawdata/online/${textbookId}/${unitId}/${filePath}`
    let unit = this.textBookInfoVo.unitList.find(unit => {return unit.id == unitId})
    
    this.frameUrl = `${auditBaseUri}/${textbookId}/${unitId}_v${unit.currentVersion}/${filePath}`
    this.baseFrameUrl = `${auditBaseUri}/${textbookId}/${unitId}_v${unit.currentVersion}/`;
    if(unit.currentVersion > 1) {
      this.diffFrameUrl = `${auditBaseUri}/${textbookId}/${unitId}_v${unit.currentVersion - 1}/${filePath}`
    }


    // this.frameUrl = `/rawdata/online/${textbookId}/${unitId}/${filePath}`
    // var frameUrln = `/rawdata/online/${this.textbookId}/${this.unitId}/c01s01n.html`
    // this.baseFrameUrl = `${auditBaseUri}/${textbookId}/${unitId}/`;
    this.fetchHTMLWithAxios(this.frameUrl, this.diffFrameUrl)
    
    // console.log(this.frameUrl)
    console.log(this.textBookInfoVo)
  },
  watch: {
    fontSize: function(newVal, oldVal) {
      document.body.className = '';
      var newClass = "font-style"+newVal;
      document.body.className = newClass;
    }
  },
  methods: {
    async loadInfoData() {
      var id = this.textbookId
      let resp = await textbookApi.getToc(id, 1)
      this.textBookInfoVo = {
        unitList: resp
      }
      this.lessonList = this.getLessonList()
      this.currentLessonIndex = this.getCurrentLessonIndex()
      // textbookApi.textBooksInfo(id).then(resp=>{
      //   console.log(resp)
      //   that.textBookInfoVo = resp
      //   that.lessonList = that.getLessonList()
      //   that.currentLessonIndex = that.getCurrentLessonIndex()
      // })
    },
    getLessonList(){
      //判断textBookInfoVo中unitList是否为空，如果不为空并且有数据，将unitList中的每一个元素的lessonList取出来判断lessonList是否为空，如果不为空，将lessonList中的每一个元素添加到lessonList中，如果为空，则不添加
      var lessonList = []
      if (this.textBookInfoVo.unitList != null && this.textBookInfoVo.unitList.length > 0) {
        this.textBookInfoVo.unitList.forEach(unit => {
          if (unit.lessonList != null && unit.lessonList.length > 0) {
            unit.lessonList.forEach(lesson => {
              lesson.unitId = unit.id
              lessonList.push(lesson)
            })
          }
        })
      }
      return lessonList
    },
    getCurrentLessonIndex(){
      //从lessonList中获取id为this.lessonId的index 是字符串判断
      return this.lessonList.findIndex(lesson => lesson.id == this.lessonId)
    },

    async fetchHTMLWithAxios(url, url2) {
      // this.loadSource()
      this.loadJsonSource()
      console.log('response1, response2');

      let response1 = await axios.get(url, {
        headers: {
          'Authorization': Authorization,
        }
      })
      console.log(response1.data);
      this.selectedElementHtml = this.getHtmlContent(response1)

      if(url2) {
        let response2 = await axios.get(url2, {
          headers: {
            'Authorization': Authorization,
          }
        })
        console.log(response2.data);
        this.selectedElementHtmlNew = this.getHtmlContent(response2)
        this.selectedElementHtmlDiff = htmldiff(this.selectedElementHtml, this.selectedElementHtmlNew);
      }

      // axios.all([
      //   axios.get(url, {
      //     headers: {
      //       'Authorization': Authorization,
      //     }
      //   }),
      //   axios.get(url2, {
      //     headers: {
      //       'Authorization': Authorization,
      //     }
      //   })
      // ])
      // .then(axios.spread((response1, response2) => {
      //   // 处理两个请求的响应
      //   console.log('response1, response2');
      //   console.log(response1.data);
      //   console.log(response2.data);
      //   this.selectedElementHtml = this.getHtmlContent(response1)
      //   this.selectedElementHtmlNew = this.getHtmlContent(response2)
      //   this.selectedElementHtmlDiff = htmldiff(this.selectedElementHtml, this.selectedElementHtmlNew);
      // })).catch(errors => {
      //   console.error(errors);
      // });
    },

    getHtmlContent(response){
      var elementHtml = ""
      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, 'text/html');
      const element = doc.querySelector('.fm_unit_horizontal');

      if (element) {
        const images = element.querySelectorAll('img');
        images.forEach(image => {
          const currentSrc = image.getAttribute('src');
          // 构造新的src属性值
          const newSrc = `${this.baseFrameUrl}${currentSrc}`;
          image.setAttribute('src', newSrc);
        });  
        elementHtml = element.outerHTML;
        // console.log(this.selectedElementHtml)
        
      } else {
        console.warn('Element with class "fm_unit_horizontal" not found.');
      }


      const article = doc.querySelector('article');
      
      if (article) {
        const images = article.querySelectorAll('img');
        images.forEach(image => {
          const currentSrc = image.getAttribute('src');
          const newSrc = `${this.baseFrameUrl}${currentSrc}`;
          image.setAttribute('src', newSrc);
        });  
        elementHtml += article.outerHTML;
        // console.log(this.articleElementHtml)
      } else {
        console.error('<article> tag not found in the provided HTML string.');
      }
      return elementHtml
    },

    loadJsonSource(){
      const jsonUrl = `${auditBaseUri}/${this.textbookId}/META-INF/sourceload.json?t=${new Date().getTime()}`
      // const jsonUrl = `/rawdata/online/${this.textbookId}/META-INF/sourceload.json?t=${new Date().getTime()}`
      axios.get(jsonUrl, {
        headers: {
          'Authorization': Authorization,
        }
      })
      .then(response => {
        // console.log("loadJsonSource--------");
        // console.log(response.data);
        this.parseCurrentSource(response.data);
      })
      .catch(error => {
        console.error('请求失败:', error);
      });
    },
    parseCurrentSource(jsonData) {
      var textbookId = this.textbookId
      var unitId = this.unitId
      var lessonId = this.lessonId
      // console.log(lessonId)
      // console.log(jsonData.lessons)
      // const lesson = jsonData.lessons.find(l => 
      //   l.lessonid === lessonId && l.fileid === undefined
      // );
      // const lesson = jsonData.lessons[0]

      // console.log(lesson)
      var currentCssList = jsonData.cssList
      var currentJsList = jsonData.jsList

      console.log(currentCssList)
      console.log(currentJsList) 
      let metainfUrl = `${auditBaseUri}/${textbookId}/META-INF/`;
      const commonUrl = `${auditBaseUri}/common/`;
      // this.loadCommomCSS()

      for(var i=0;i<currentCssList.length;i++){
        var path = currentCssList[i]
        if(path.indexOf('annotator.css') != -1){
          continue
        }
        //判断是否包含字符串'../META-INF/'
        if(path.indexOf('../META-INF/') != -1){
          path = path.replace('../META-INF/', metainfUrl);
        }
        if(path.indexOf('../../common/') != -1){
          path = path.replace('../../common/', commonUrl);
        }
        
        loadCSS(path,true)
      }

      // this.loadCommomJS()

      //exclude jquery js
      currentJsList = currentJsList.filter(item => {return !item.includes('jquery')})

      for(var i=0;i<currentJsList.length;i++){
        var path = currentJsList[i]
        if(path.indexOf('annotator.js') != -1){
          continue
        }
        // path = path.replace('../../common/', commonUrl);
        if(path.indexOf('../META-INF/') != -1){
          path = path.replace('../META-INF/', metainfUrl);
        }
        if(path.indexOf('../../common/') != -1){
          path = path.replace('../../common/', commonUrl);
        }
        console.log(path)
        loadBodyJS(path,null,true)
      }

    },
    /*
    loadCommomCSS(){
      var cssArr = [
        '../../common/css/base.css',
        '../../common/css/mobile.css',
        // '../../common/css/annotator.css',
        '../../common/css/html5tooltips.animation.css',
        '../../common/css/html5tooltips.css'

      ]
      const absoluteCssUrls = this.toAbsoluteUrls(cssArr, auditBaseUri);
      for (let i = 0; i < absoluteCssUrls.length; i++) {
        loadCSS(absoluteCssUrls[i],true)
      }

    },

    loadCommomJS(){
      
      var jsArr = [
        '../../common/js/dsbridge.js',
        '../../common/js/jquery.min.js',
        // '../../common/js/annotator.js',
        '../../common/js/mark.min.js',
        '../../common/js/html5tooltips.js',
        '../../common/js/global.js',
        '../../common/js/answer.js',
        '../../common/MathJax/MathJax.js?config=MML_HTMLorMML-full'
      ]
      const absolutejsUrls = this.toAbsoluteUrls(jsArr, auditBaseUri);
      for (let i = 0; i < absolutejsUrls.length; i++) {
        loadBodyJS(absolutejsUrls[i], ()=>{
          console.log('loaded')
        },true)
      }
    },*/
    goPracticeView() {
      this.$router.push({name: 'Practice'})
    },
    showCatalog(){
      this.drawer = true
    },
    showPre(){
      //如果currentLessonIndex==0 
      if(this.currentLessonIndex==0){
        this.$message.error('已经是第一课了')
      }else{
        
        this.currentLessonIndex = this.currentLessonIndex-1
        var currentLesson = this.lessonList[this.currentLessonIndex]
        var unitId = currentLesson.unitId
        this.gotoDetail(unitId,currentLesson)
      }
    },
    showNext(){
      if(this.currentLessonIndex==this.lessonList.length-1){
        this.$message.error('已经是最后一课了')
      }else{
        
        this.currentLessonIndex = this.currentLessonIndex+1
        var currentLesson = this.lessonList[this.currentLessonIndex]
        var unitId = currentLesson.unitId
        this.gotoDetail(unitId,currentLesson)
      }
    },
    changeFont(){
      this.showFontsizeChangeTool = !this.showFontsizeChangeTool
    },
    gotoDetail(unitid,lesson){
      removeAllDetailSource()
      console.log(lesson)

      var titleStr = lesson.serialName+" "+lesson.title
      this.title = titleStr
      this.unitId = unitid+""
      this.filePath = lesson.filePath
      this.lessonId = lesson.id+""

      document.title = this.title
      // this.frameUrl = "/rawdata/online/8093380284517515264/7989331510455501330/c01s01.html?Expires=1719976537&OSSAccessKeyId=TMP.3KjQ42hkhHuyD2bhKnPp7pioJKauNDad3ZK9efXJeUDSyTiwY6zp5fX3uPtH3wWPFZxAnX8gNSbACr7feBcq8iUMdpWUek&Signature=0X5akI6AtP02%2FnK%2FizgePh3ZBK4%3D"
      // this.frameUrl = `https://cdn.aefree.com/rawdata/online/${textbookId}/${unitId}/${filePath}`
      this.frameUrl = `/rawdata/online/${this.textbookId}/${this.unitId}/${this.filePath}`
      var frameUrln = `/rawdata/online/${this.textbookId}/${this.unitId}/c01s01n.html`
      this.baseFrameUrl = `${auditBaseUri}/${this.textbookId}/${this.unitId}/`;
      this.fetchHTMLWithAxios(this.frameUrl,frameUrln)
      
      // console.log(this.frameUrl)
      console.log(this.textBookInfoVo)
      this.drawer = false
    },
    //meta-inf
    toMetaInfSourceUrls(cssArr, auditBaseUri) {
      const normalizedBaseUri = auditBaseUri.replace('&#39;', "'") + '';

      return cssArr.map(cssPath => {
        // 替换所有'../../'为'/'
        let absolutePath = cssPath.replace(/\.\.\//g, '/');
        absolutePath = absolutePath.replace(/\/\/+/g, '/');
        // 拼接baseUri和处理后的路径
        return normalizedBaseUri + absolutePath;
      });
    },
    //commom
    toAbsoluteUrls(cssArr, auditBaseUri) {
      const normalizedBaseUri = auditBaseUri.replace('&#39;', "'") + '';

      return cssArr.map(cssPath => {
        let absolutePath = cssPath.replace(/\.\.\//g, '/');
        absolutePath = absolutePath.replace(/\/\/+/g, '/');

        // 拼接baseUri和处理后的路径
        return normalizedBaseUri + absolutePath;
      });
    }
  },
  
}
</script>

<style lang="less" scoped>
.area-title {
  text-align: center;
  color: #000000;
  font-size: 20px;
  font-weight: bold;
}
.home{
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 800px;
}

.header-view{
  position: fixed;
  width: 100%;
  height: 60px;
  color: #4a4aff;
  text-align: center;
  font-size: 23px;
  font-weight: 500;
  background: white;
  line-height: 60px;
  border-bottom: 2px solid #f0f0f0;
  z-index: 100001;
}

/deep/ .el-main{
    background-color: #F6F6F6;
    color: #333;
    text-align: center;
    padding:0px;
}

.main-view{
  display: flex;
  flex-direction: row;
  width: 90%;
  background: #ffffff;
  margin-top: 60px;
  padding-bottom: 90px;
  min-width: 1300px;
  .html{
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #bcbcbc;
  }
  .title-view{
    font-weight: 400;
    font-size: 20px;
    color: #191919;
    text-align: left;
    margin-top: 50px;
  }
  .category-list{
    display: flex;
    flex-direction: row;
    font-size: 14px;
    color: #7F7F7F;
    margin-top: 30px;
    .category-name{
      margin-right: 20px;
    }
  }
  .book-list{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 50px;
    padding-left: 10px;
    .book-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 15px;
      .image-v{
        display: flex;
        flex-direction: column;
        width: 214px;
        height: 272px;
        background: #F6F8FA;
        border-radius: 6px 6px 6px 6px;
        align-items: center;
        justify-content: center;
        .book-cover{
          width: 158px;
          height: 212px;
        }
      }
      .book-title{
        width: 200px;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin-top: 20px;
      }
      .book-price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-top: 10px;
      }
    }
  }
}

.pagination{
  margin-top: 50px;
  margin-bottom: 50px;
}

.main-content{
  display: flex;
  flex-direction: column;
  margin-left: 180px;
  margin-right: 180px;
  margin-top: 100px;
  margin-bottom: 100px;
  .l1-title{
    color: #72BEFF;
    font-size: 30px;
    font-weight: bold;
  }
  .l2-title{
    color: #666666;
    font-size: 20px;
    margin-left: 30px;
    font-weight: bold;
  }
  .title-view{
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  .text-content{
    font-weight: 400;
    font-size: 15px;
    color: #191919;
    text-align: left;
    line-height: 28px;
    margin-top: 20px;
  }
  .sub-text-content{
    display: flex;
    flex-direction: row;
    .l2-title{
      margin-left: 0px;
      margin-top: 30px;
    }
    .sub-text-content-left{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-right: 60px;
    }
    .sub-text-content-right{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 60px;
      .text-content{
        line-height: 29px;
      }
    }
  }
}



.book{
  display: flex;
  flex-direction: column;
  
  .book-info{
    display: flex;
    flex-direction: row;
    margin-top: 28px;
    .book-cover{
      width: 212px;
      height: 292px;
      border-radius: 0px 0px 0px 0px;
    }
    .info-detail{
      display: flex;
      flex-direction: column;
      flex: 1;
      .name-view{
        display: flex;
        flex-direction: row;
        .book-name{
          font-weight: 400;
          font-size: 22px;
          color: #191919;
          margin-left: 20px;
        }
        .other-book{
          width: 120px;
          height: 34px;
          background: #72BEFF;
          border-radius: 6px 6px 6px 6px;
          line-height: 34px;
          color: white;
          margin-left: auto;
          cursor: default;
        }
      }
      .info-labels{
        display: flex;
        flex-direction: row;
        text-align: left;
        margin-top: 20px;
        .label{
          margin-left: 20px;
          line-height: 30px;
          font-weight: 400;
          font-size: 14px;
          color: #7F7F7F;
        }
      }
    }
    .price-view{
      width: 450px;
      height: 50px;
      margin-top: 10px;
      background: #F2F4F5;
      border-radius: 6px 6px 6px 6px;
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      align-items: center;
      .label{
        font-weight: 400;
        font-size: 14px;
        color: #191919;
        margin-left: 20px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-left: 10px;
      }
      .buttons-view{
        margin-left: auto;
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        .read-btn{
          width: 80px;
          height: 28px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #72BEFF;
          line-height: 28px;
          border-radius: 4px;
          cursor: default;
        }
        .buy-btn{
          width: 80px;
          height: 28px;
          margin-left: 10px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 28px;
          border-radius: 4px;
          background: #72BEFF;
          cursor: default;
        }
      }
    }

  }
  .book-detail{
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    .buttons-view{
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      
      .content-summary{

      }

      .author-info{
        margin-left: 30px;
      }

      .catalog-info{
        margin-left: 30px;
      }

    }
    .content-line{
      background: #F2F4F5;
      height: 1px;
      width: 100%;
      margin-top: 10px;
    }
    .contents{
      width: 100%;
      margin-top: 10px;
      min-height: 400px;
      font-weight: 400;
      font-size: 14px;
      color: #7F7F7F;
      line-height: 36px;
      margin-top: 50px;
      
    }
  }
}
.font-slider{
  position: fixed;
  z-index: 1001;
  bottom: 80px;
  right: 80px;
  width: 150px;
  height: 60px;
  background-color: #c4c4c4;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
}
.tools-view{
  position: fixed;
  z-index: 1001;
  bottom: 150px;
  right: 230px;
  display: flex;
  flex-direction: column;
  .btns-div{
    display: flex;
    flex-direction: column;
    width: 40px;
    height: 40px;
    align-items: center;
    background-color: #c4c4c4;
    justify-content: center;
    border-radius: 20px;
    margin-top: 20px;
  }
  .tool-img{
    width: 20px;
    height: 20px;
  }
}
.catalog{
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top:50px;
}


/deep/ ins {
  text-decoration: none;
  background-color: rgb(156, 248, 156);
}

/deep/ del {
  text-decoration: line-through;
  background-color: rgb(251, 151, 151);
  color: #555;
}
/deep/ del img{
  border: 2px solid rgb(251, 151, 151);
}

/deep/ ins img{
  border: 2px solid rgb(156, 248, 156);
}
</style>
